function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwinPeaks = function SvgTwinPeaks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1730.568 992.015"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.223 330.672h-31.162S376.003 739.706 0 758.083v233.924s407.484 8.096 432.642-497.114c25.158 505.21 432.642 497.114 432.642 497.114V758.083c-376.003-18.377-417.06-427.411-417.06-427.411M1313.507 0h-31.162s-41.058 409.034-417.061 427.412v233.924s407.484 8.095 432.642-497.115c25.158 505.21 432.642 497.115 432.642 497.115V427.412C1354.565 409.034 1313.508 0 1313.508 0",
    style: {
      fill: "#a25138"
    }
  }))));
};
export default SvgTwinPeaks;